export default __webpack_public_path__ + "static/fashion_mood-e5b984a0a1011a88cfee6edfb1a87897.png";